import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import Prescriptions from "../layouts/Prescriptions";
// import Bills from "../layouts/Bills";
import LabTest from "../layouts/LabTest";
import Certificates from "../layouts/Certificates";
import UplaodReport from "../layouts/UplaodReport";
// import CuModal from "../../common_component/component/CuModal";
import { medicalTabs } from "../../_helper/constant/constant";
import CuMobileModal from "../components/CuMobileModal";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useUserItemsFilter } from "../../_helper/actions/app/items";
import Appointments from "./Appointments";
import { PiUploadSimpleBold } from "react-icons/pi";
// import PAppointmentCard from "../components/PAppointmentCard";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAtom } from "jotai";
import { toast } from "react-toastify";
import CuButton from "../components/CuButton";
import { useUploadRecordfile } from "../../_helper/actions/mutation/image";
import Modal from "../../common_component/component/Modal";
import MobileModal from "../../common_component/component/MobileModal";
// import MobileModal from "../../new_appointment/appoinment/components/MobileModal";
// import MobileModal from "../../new_appointment/appoinment/components/MobileModal";

const Records = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sm = !useMediaQuery({ query: "(min-width:1024px)" });
  // const [activeTab, setActiveTab] = useState("Appointments");
  const [openMobileModal, setOpenMoileModal] = useState(false);
  const optionTab = searchParams.get("option-tab");
  const params = new URLSearchParams();
  const [recordId, setRecordId] = useState(optionTab);
  const [reportName, setReportName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  // //("option tab------", optionTab, recordId);

  const handleTabChange = (tab) => {
    // setActiveTab(tab);
    params.set("option-tab", tab.toLowerCase());
    if (option) params.set("option", option);
    if (allClinic) params.set("all_clinic", allClinic);
    if (userId) params.set("userId", userId);
    navigate({ search: params.toString() });
  };

  // const { id } = useParams();
  const option = searchParams.get("option");
  const allClinic = searchParams.get("all_clinic");
  const userId = searchParams.get("userId");

  const [clinic] = useAtom(clinicAtom);

  const queryforUser = `?action=getUserRecords&clinic_id=${clinic?.id}&frontend=True&patients_id=${userId}&file_type=${optionTab}`;
  const { data, isLoading } = useUserItemsFilter(
    ApiEndPoint.USERS,
    queryforUser,
    optionTab !== "appointments" && clinic ? true : false
  );

  const components = [
    {
      name: "Appointments",
      component: () => <Appointments />,
    },
    {
      name: "Prescriptions",
      component: (data) => <Prescriptions data={data} isLoading={isLoading} />,
    },
    {
      name: "Certificate",
      component: (data) => <Certificates data={data} isLoading={isLoading} />,
    },
    {
      name: "Lab Test",
      component: (data) => <LabTest data={data} isLoading={isLoading} />,
    },
  ];

  const uploadfileAndSubmit = useUploadRecordfile({
    file_name: reportName,
    file_description: description,
    file_type: recordId,
    user_details: userId,
    record_date: selectedDate,
  });

  const handleSubmit = () => {
    if (!selectedFile || selectedFile.length === 0) {
      toast.error("Select File");
      return;
    } else if (!reportName) {
      toast.error("Select Report Name");
      return;
    }

    const filesArray = Array.from(selectedFile);
    const formdata = new FormData();
    filesArray.forEach((file) => {
      formdata.append("files", file);
    });
    formdata.append("upload_to", "patients");
    formdata.append("patient_id", userId);

    uploadfileAndSubmit.mutate(formdata, {
      onSuccess: (data) => {
        setRecordId("");
        setReportName("");
        setDescription("");
        setSelectedFile("");
        setOpenMoileModal(false);
        setSelectedDate("");
        // //("onSuccess------", data);
      },
    });
  };

  return (
    <div className="h-full px-5 w-full  overflow-auto relative">
      <div className="w-full  ">
        <div className="w-full cu-records-tab overflow-x-auto">
          <div>
            <div className="flex gap-3 my-4 w-[550px]">
              {medicalTabs.map((tab) => (
                <button
                  key={tab.name}
                  className={`${
                    optionTab.toLocaleLowerCase() ===
                    tab.name.toLocaleLowerCase()
                      ? "bg-[#C7EAC9]"
                      : "bg-white border-[0.5px] border-[#00000033]"
                  } h-[38px] px-6 mr-2 rounded-full min-w-[135px]`}
                  onClick={() => handleTabChange(tab.name)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-4">
          {medicalTabs.map((tab, ind) =>
            optionTab.toLocaleLowerCase() === tab.name.toLocaleLowerCase()
              ? components[ind].component(data)
              : // <div key={tab.name}>{tab.component}</div>
                null
          )}
        </div>
      </div>
      {sm && (
        <MobileModal
          isOpen={openMobileModal}
          closeModal={() => setOpenMoileModal(false)}
        >
          <div className="px-4 pb-4">
            <div className="cu-records overflow-auto w-full">
              <UplaodReport
                setOpenMoileModal={setOpenMoileModal}
                handleSubmit={handleSubmit}
                reportName={reportName}
                setReportName={setReportName}
                description={description}
                setDescription={setDescription}
                recordId={recordId}
                setRecordId={setRecordId}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
              />
            </div>
            <div className="w-full mt-4">
              <CuButton
                className={`w-full border border-[#00000033] py-2 px-4 rounded-md bg-[#C7EAC9]`}
                onClick={handleSubmit}
                isLoading={uploadfileAndSubmit.isLoading}
              >
                Submit
              </CuButton>
            </div>
          </div>
        </MobileModal>
      )}

      {!sm && openMobileModal && (
        <Modal
          isOpen={openMobileModal}
          onClose={() => setOpenMoileModal(false)}
        >
          <Modal.Header>
            <div className="py-2 flex justify-between items-center">
              <div className="text-lg font-semibold">Upload Report</div>
              <button
                onClick={() => setOpenMoileModal(false)}
                className="text-gray-600 hover:text-gray-900 text-xl"
              >
                &times;
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="w-[400px] mt-1">
              <UplaodReport
                setOpenMoileModal={setOpenMoileModal}
                handleSubmit={handleSubmit}
                reportName={reportName}
                setReportName={setReportName}
                description={description}
                setDescription={setDescription}
                recordId={recordId}
                setRecordId={setRecordId}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="w-full py-2">
              <CuButton
                className="w-full border border-[#00000033] py-2 px-4 rounded-md bg-[#C7EAC9]"
                onClick={handleSubmit}
                isLoading={uploadfileAndSubmit.isLoading}
              >
                Submit
              </CuButton>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {optionTab !== "appointments" && (
        <>
          {sm && (
            <div
              className="fixed flex justify-center items-center gap-2  bottom-[100px] right-5 bg-[#C7EAC9] py-2 px-4 rounded-full border-[0.5px] border-[#00000033]"
              onClick={() => setOpenMoileModal(true)}
            >
              <PiUploadSimpleBold />
              <span>Upload New</span>
            </div>
          )}
          {!sm && (
            <div
              className="flex justify-center items-center gap-2 absolute top-4 right-4 cursor-pointer bg-[#C7EAC9] py-2 px-4 rounded-full border-[0.5px] border-[#00000033]"
              onClick={() => setOpenMoileModal(true)}
            >
              <PiUploadSimpleBold />
              <span>Upload New</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Records;
